<template>
  <Navbar v-model:show-events-modal="showConferenceModal" />
  <secondNav></secondNav>
  <main style="position: relative" id="teacher-meetings-scroller">
    <div class="container">
      <DrawerEvents v-model:show="showConferenceModal"></DrawerEvents>

      <template v-if="conferenceStore.loading && !conferenceStore.conferences.length">
        <div class="d-flex align-center justify-center" style="height: 100%">
          <LoadingState text="Loading Conference Data"></LoadingState>
        </div>
      </template>
      <div v-else class="w-100">
        <template v-if="days.length">
          <ConferenceDaysNav
            style="max-width: 540px; margin: auto; margin-top: 20px"
            :active-day="''"
            :days="days"
            scroller
          ></ConferenceDaysNav>
        </template>
        <template
          v-for="(day, i) in days"
          :key="day.conference_days_id + ('-team' ? conferenceStore.selected.team || {} : '')"
        >
          <agendaCard :day-index="i" :conference-day="day!"> </agendaCard>
        </template>
      </div>
    </div>
    <GoToTop scroll-el-id="teacher-meetings-scroller" :appear-px="300"></GoToTop>
  </main>
</template>

<script lang="ts" setup>
import Navbar from "@/components/teacher/Navbar.vue";
import { useConferenceStore } from "@/stores/teacher/conference";
import { useSchoolStore } from "@/stores/school";
import { useRoute } from "vue-router";
import secondNav from "@/components/teacher/secondNav.vue";
import { onMounted, ref } from "vue";
import agendaCard from "@/components/teacher/agendaCard.vue";
import DrawerEvents from "@/components/teacher/DrawerEvents.vue";
import { sort } from "@/utils/sort";
import LoadingState from "@/components/loadingState.vue";
import { computed } from "vue";
import ConferenceDaysNav from "@/components/ConferenceDaysNav.vue";
import GoToTop from "@/components/global/goToTop.vue";
const route = useRoute();

const conferenceStore = useConferenceStore();
const schoolStore = useSchoolStore();

const showConferenceModal = ref(false);

const days = computed(() => sort(conferenceStore.selected?.conference_days || [], (i) => i.start));

onMounted(async () => {
  await conferenceStore.loadingPromise;
  if (schoolStore.school == null || schoolStore.school?.school_id == undefined) {
    if (route.params.account != null && route.params.account != "") {
      schoolStore.loadSchool(route.params.account).then(() => {
        console.log("School found");
      });
    } else {
      window.location.href = "https://www.ptcwizard.com";
    }
  }
});
</script>
